import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import TextField from '../Forms/TextField';
import InputText from './InputText';

const PasswordTextForm = ({
  id,
  handleChange,
  variant,
  value,
  height,
  error,
  label,
  fullWidth,
  gridProps,
  isLoginForm,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);

  const passwordTextStyle = {
    width: 30,
    position: 'absolute',
    background: 'none',
    border: 'none',
    fontSize: 24,
    height: 30,
    right: 30,
    top: 13,
    color: 'var(--light_blue_grey)',
  };
  const iconStyle = {
    fontSize: 30,
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    if (/^[a-zA-Z0-9@:._]*$/.test(newValue)) {
      handleChange(e);
    }
  };

  return (
    <Grid {...gridProps} style={{ position: 'relative', marginTop: isLoginForm && '16px' }}>
      <TextField
        onChange={handleInputChange}
        value={value}
        height={height}
        fullWidth={fullWidth}
        error={error}
        variant={variant}
        label={label}
        id={id}
        type={isVisible ? 'text' : 'password'}
        {...props}
      />
      <button
        className="eye"
        style={passwordTextStyle}
        id={`button-password-text-img${id}`}
        onClick={() => setIsVisible(!isVisible)}
      >
        {isVisible ? (
          <VisibilityOutlinedIcon style={iconStyle} />
        ) : (
          <VisibilityOffOutlinedIcon style={iconStyle} />
        )}
      </button>
    </Grid>
  );
};

InputText.propType = {
  id: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
  value: PropTypes.string.isRequired,
  height: PropTypes.string,
  label: PropTypes.string,
  fullWidt: PropTypes.string,
  gridProps: PropTypes.object,
};

export default PasswordTextForm;
